import * as t from 'io-ts'
import { Org } from '@espoon-voltti/org-ts-api'

import { omit } from '../../utils/types'

// NuorA doesn't store modifiedAt and modifiedBy in the org snapshot
export const OrgDto = t.type(omit(Org.props, ['modifiedAt', 'modifiedBy']))
export type OrgDto = t.TypeOf<typeof OrgDto>
